import { Paper, Box, Chip, Typography, useMediaQuery } from '@mui/material';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import { useSwiper } from 'swiper/react';
import styles from './styles';
import { CheckMarkInCircleIcon } from '../../kit/icons/CheckMarkInCircleIcon';

export default function ProgramElement(props) {
  const {
    phase,
    backgroundColor,
    minHeight,
    height,
    bgImage,
    width,
    isCareerCenter = false,
    zeroElevation,
  } = props;
  const isXs = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const swiper = useSwiper();
  const isSwiperLoaded = swiper?.slides?.length > 0;

  return (
    <Paper
      elevation={isCareerCenter || zeroElevation ? 0 : 1}
      sx={{
        backgroundColor,
        ...styles.root(
          isXs,
          height || minHeight,
          isSwiperLoaded || isXs,
          width,
        ),
      }}
    >
      {bgImage && (
        <GatsbyImage
          style={styles.bgImageBlock}
          imgStyle={styles.bgImage}
          image={getImage(bgImage)}
          alt={`card-${phase}`}
          loading="lazy"
        />
      )}
      <ProgramElementContent {...props} isXs={isXs} isCareerCenter />
    </Paper>
  );
}

function ProgramElementContent({
  period,
  phase,
  description,
  bgImage,
  fontSize,
  isXs,
  isCareerCenter = false,
  withCircleIcon = false,
}) {
  return (
    <>
      <Box
        sx={
          phase
            ? styles.header(!!bgImage, isXs)
            : { ...styles.header(!!bgImage, isXs), ...styles.alignItemsTop }
        }
      >
        <Typography
          variant="desktopH4"
          color="kit.text.h"
          sx={phase && styles.period(!!bgImage)}
        >
          {period}
        </Typography>
        {withCircleIcon && <CheckMarkInCircleIcon />}
        {phase && (
          <Chip
            color="secondary"
            size="small"
            variant={isCareerCenter ? 'filled' : 'status'}
            label={phase}
            sx={{
              ml: isCareerCenter ? '16px' : 'auto',
              mt: isCareerCenter && '0.4em',
            }}
          />
        )}
      </Box>
      <Typography
        component={'div'}
        color="kit.text.secondary"
        variant="desktopP2"
        sx={{ fontSize, ...styles.description }}
      >
        {Array.isArray(description)
          ? description.map((item) => (
              <Typography key={item}>• {item}</Typography>
            ))
          : description}
      </Typography>
    </>
  );
}
